import React from 'react';

import {useStore} from 'effector-react';

import {
    CUSTOMS_NAVIGATION_LINKS,
    LinkData,
    NAVIGATION_LINKS,
    NK_NAVIGATION_LINKS,
    NavigationLinksShowEnum,
} from 'core/navigationLinks';

import {ROUTE} from 'core/routes';

import {isAdmin$, isCustomsDirector$, isCustomsRole$, isNkRole$, permissions$} from 'models/auth';
import {hasAccess} from 'utils/roles';

import {MenuIcon, MenuItem, MenuItemTitle, SidebarMenu} from './styled';

interface Props {
    isMobile?: boolean;
    onClickHandler?: Function;
}

export function SidebarNavigation({isMobile, onClickHandler = () => {}}: Props) {
    const isAdmin = useStore(isAdmin$);
    const isCustomsRole = useStore(isCustomsRole$);
    const isCustomsDirector = useStore(isCustomsDirector$);
    const isNkRole = useStore(isNkRole$);
    const permissions = useStore(permissions$);

    const EXTRA_ACTIVE_PATH_FOR_DOCUMENTS = {
        [ROUTE.DOCUMENTS_DOCUMENTS]: true,
        [ROUTE.DOCUMENTS_INVOICES]: true,
        [ROUTE.DOCUMENTS_CHECKS]: true,
        [ROUTE.DOCUMENTS_INVOICES_INCOMING]: true,
        [ROUTE.DOCUMENTS_INVOICES_OUTGOING]: true,
        [ROUTE.DOCUMENTS_GDS]: true,
        [ROUTE.DOCUMENTS_GDS_CREATE]: true,
    };

    const NAVIGATION_MAP: {
        DEFAULT: LinkData[];
        CUSTOMS_DIRECTOR: LinkData[];
        CUSTOMS_EMPLOYEE: LinkData[];
        NK: LinkData[];
    } = {
        CUSTOMS_DIRECTOR: CUSTOMS_NAVIGATION_LINKS,
        CUSTOMS_EMPLOYEE: CUSTOMS_NAVIGATION_LINKS.filter(
            (link) => link.route !== ROUTE.DOCUMENTS_DOCUMENTS,
        ),
        NK: NK_NAVIGATION_LINKS,
        DEFAULT: NAVIGATION_LINKS.filter((link) => {
            if (link.route === ROUTE.DECLARATIONS) {
                return isAdmin;
            }
            return true;
        }),
    };

    let role: keyof typeof NAVIGATION_MAP = 'DEFAULT';

    if (isCustomsRole) {
        role = isCustomsDirector ? 'CUSTOMS_DIRECTOR' : 'CUSTOMS_EMPLOYEE';
    }

    if (isNkRole) {
        role = 'NK';
    }

    const NAVIGATION = NAVIGATION_MAP[role];

    const links = NAVIGATION.filter(
        (link) =>
            link.showOn !== NavigationLinksShowEnum[isMobile ? 'desktop' : 'mobile'] &&
            (!link.permissions || hasAccess(permissions, link.permissions)),
    );

    return (
        <SidebarMenu>
            {links.map((item, index) => (
                <MenuItem
                    to={item.route}
                    key={index}
                    isActive={(match: any, location) =>
                        (item.route === ROUTE.PRODUCTS_GRID &&
                            location.pathname.startsWith('/products/')) ||
                        (item.route === ROUTE.DOCUMENTS_DOCUMENTS &&
                            location.pathname.startsWith(ROUTE.DOCUMENTS_INVOICES)) ||
                        (item.route === ROUTE.DOCUMENTS_DOCUMENTS &&
                            location.pathname.startsWith('/gds/')) ||
                        location.pathname.startsWith(item.route) ||
                        (item.route === ROUTE.DOCUMENTS_DOCUMENTS &&
                            location.pathname in EXTRA_ACTIVE_PATH_FOR_DOCUMENTS) ||
                        match
                    }
                    onClick={(e: any) => item.onClick?.(e) ?? onClickHandler(e)}
                >
                    <MenuIcon>{item.icon}</MenuIcon>
                    <MenuItemTitle>{item.title}</MenuItemTitle>
                </MenuItem>
            ))}
        </SidebarMenu>
    );
}
